export default __webpack_public_path__ + "static/couchnight-00fe49c9553eb4cb3d054d601e6723fe.png";